export const EXCMREGION_DELETE_RESET = 'EXCMREGION_DELETE_RESET'
export const EXCMREGION_DELETE_SET_ERROR = 'EXCMREGION_DELETE_SET_ERROR'
export const EXCMREGION_DELETE_SET_DELETED = 'EXCMREGION_DELETE_SET_DELETED'
export const EXCMREGION_DELETE_TOGGLE_LOADING = 'EXCMREGION_DELETE_TOGGLE_LOADING'
